import React from 'react';
import classNames from 'classnames';
import styles from './AppContentMaxWidth.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}
function AppContentMaxWidth({ children, className }: Props) {
  return <div className={classNames(styles.root, className)}>{children}</div>;
}

export default AppContentMaxWidth;
